/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Provision_WonInputs */

const cs_reports_col_provision_won = /** @type {(inputs: Reports_Col_Provision_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získaná`)
};

const en_reports_col_provision_won = /** @type {(inputs: Reports_Col_Provision_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Won`)
};

/**
* | output |
* | --- |
* | "Won" |
*
* @param {Reports_Col_Provision_WonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_col_provision_won = /** @type {((inputs?: Reports_Col_Provision_WonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Provision_WonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_provision_won(inputs)
	return cs_reports_col_provision_won(inputs)
});